module.exports = __webpack_public_path__ + "static/media/129.c2d2f5bb.webp";